import ForgotPasswordComponent from '@/views/ForgotPassword.vue';
import RouteNames from '../constants/route-names';

const forgotPasswordRoute = {
  component: ForgotPasswordComponent,
  name: RouteNames.ForgotPassword,
  path: '/forgot-password',
  props: route => ({
    email: route.query.email,
  }),
};

export default forgotPasswordRoute;
